'use client'

import { LoadingOutlined } from '@ant-design/icons'
import { Flex, Spin } from 'antd'
import React from 'react'

export function AuthLoader() {
  return (
    <Flex justify="center" align="center" className="mobileContainer">
      <Spin indicator={<LoadingOutlined spin />} size="large" />
    </Flex>
  )
}
